module.exports = __webpack_public_path__ + "static/media/imagem3d.22fa6bf3.svg";